
import { Component, Vue } from "vue-property-decorator";
import { getAPIAuthorizedHeader } from "@/services/common";
import Axios from "axios";
import { API_STORE } from "@/config";
import * as mfs100 from "@/assets/js/mantra_mfs100.js";
import AsyncPageLoader from "@/views/AsyncPageLoader.vue";
import { AEPSKycRequest, AEPSVerifyKycRequest } from "@/models/common";

@Component({ components: { AsyncPageLoader } })
export default class UserAepsKyc extends Vue {
  public asyncPageLoader = false;
  public userKycVerifyed = false;
  public isOtpAndKycPage = false;
  public isCaptured = false;
  public latitude = null;
  public longitude = null;
  public agentId = "";
  public updateKycRequest = new AEPSKycRequest();
  public verifyKycRequest = new AEPSVerifyKycRequest();
  public aepsKycUrl = null;

  //Update Kyc
  public async updateUserKyc() {
    this.updateKycRequest.userId = this.$userId;
    this.updateKycRequest.latitude = this.latitude;
    this.updateKycRequest.longitude = this.longitude;
    this.$showLoader(true);
    let response = await Axios.post(
      API_STORE.SERVICE + "updateUserKyc",
      this.updateKycRequest,
      {
        headers: getAPIAuthorizedHeader(),
      }
    );
    this.$showLoader(false);
    if (response) {
      if (response.data.agentId) {
        this.isOtpAndKycPage = true;
        this.verifyKycRequest.agentId = response.data.agentId;
        this.agentId = response.data.agentId;
        this.$snotify.success(response.data.message);
      } else {
        this.isOtpAndKycPage = false;
        this.$snotify.error(response.data.message);
      }
    }
  }

  //Verify otp and kyc
  public async verifyOtpAndKyc() {
    this.verifyKycRequest.kycPidInformation = (<HTMLInputElement>(
      document.getElementById("fingerPrintBiometicData")
    )).value;
    this.verifyKycRequest.deviceSerialNumber = (<HTMLInputElement>(
      document.getElementById("fingerPrintDeiveId")
    )).value;
    this.$showLoader(true);
    if (
      this.verifyKycRequest.otp &&
      this.verifyKycRequest.agentId &&
      this.verifyKycRequest.kycPidInformation &&
      this.verifyKycRequest.deviceSerialNumber
    ) {
      let response = await Axios.post(
        API_STORE.SERVICE + "verifyAepsKyc",
        this.verifyKycRequest,
        {
          headers: getAPIAuthorizedHeader(),
        }
      );
      this.$showLoader(false);
      if (response && response.data) {
        this.userKycVerifyed = true;
        this.isOtpAndKycPage = false;
        this.$snotify.success(response.data.message);
      }
    } else {
      this.$snotify.error(
        "Finger print not capture successfully or otp not validate!"
      );
      this.$showLoader(false);
    }
  }

  //Kyc resend otp
  public async kycResendOtp() {
    this.$showLoader(true);
    let response = await Axios.get(
      API_STORE.SERVICE + `kycResendOtp/${this.agentId}`,
      {
        headers: getAPIAuthorizedHeader(),
      }
    );
    this.$showLoader(false);
    if (response && response.data) {
      this.$snotify.error(response.data.message);
    }
  }

  //Capture finger print
  public async captureFingerPrint() {
    mfs100.getDeviceInfo("KYC", null);
    this.$showLoader(true);
    setTimeout(
      function (scope) {
        scope.$showLoader(false);
        scope.isCaptured = true;
      },
      2000,
      this
    );
  }

  //Get user aeps kyc
  public async getUserAepsKyc() {
    let response = await Axios.get(
      API_STORE.COMMON + `checkUserAepsKyc/${this.$userId}`,
      {
        headers: getAPIAuthorizedHeader(),
      }
    );
    if (response && response.data) {
      this.userKycVerifyed = response.data.kycVerifyed;
    }
  }

  public async requestKycOnboarding() {
    let response = await Axios.get(
      API_STORE.COMMON + `aepsKycOnboardingRequest/${this.$userId}`,
      {
        headers: getAPIAuthorizedHeader(),
      }
    );

    if (response && response.data) {
      this.aepsKycUrl = response.data.kycUrl;
      // this.userKycVerifyed = response.data.kycUrl;
    }
  }

  //Get user aeps kyc
  public async getUserDetails() {
    let response = await Axios.get(
      API_STORE.COMMON + `checkUserAepsKyc/${this.$userId}`,
      {
        headers: getAPIAuthorizedHeader(),
      }
    );
    if (response && response.data) {
      this.userKycVerifyed = response.data.kycVerifyed;
    }
  }

  //get lat or long
  public async initGeolocation() {
    if (navigator.geolocation) {
      // Call getCurrentPosition with success and failure callbacks
      navigator.geolocation.getCurrentPosition(this.success, this.fail);
    } else {
      alert("Sorry, your browser does not support geolocation services.");
    }
  }

  public async success(position) {
    this.latitude = position.coords.latitude;
    this.longitude = position.coords.longitude;
  }

  public async fail() {
    alert("Enable your location");
  }

  mounted() {
    this.getUserAepsKyc();
    this.initGeolocation();
  }
}
